namespace Areas.Eic.List {
    "use strict";

    export function viewLink(cellElement, cellInfo) {
        buildCellContent(cellElement,
            () => { return cellInfo.key; },
            "<a href= '/Eic/View/Index/{placeholder}'>View</a>");
    }

    export function showCreate() {
        var dialog = new Areas.Dialogs.CreateEic.CreateEicDialog(() => {});
    }

    export function create() {
        location.href = "/Eic/Create/Index";
    }

    export function view() {
        gotoSelected("EicGrid", "/Eic/View/Index/");
    }

    export function edit() {
        gotoSelected("EicGrid", "/Eic/Edit/Index/");
    }

    export function review() {
        gotoSelected("EicGrid", "/Eic/Review/Index/");
    }

    export function onGridSelectionChanged(e) {
        const rowSelected = e.selectedRowsData.length === 1;

        if (rowSelected) {
            const status: string = e.selectedRowsData[0].status;
            const canBeModified =
                (status !== Constants.EicStatus.deleted
                && status !== Constants.EicStatus.completed);

            if (canBeModified) {
                if (isEditable(status)) {
                    enableButton("EditButton");
                } else {
                    disableButton("EditButton");
                }

                if (isReviewable(status)) {
                    enableButton("ReviewButton");
                } else {
                    disableButton("ReviewButton");
                }
            }
        }

    }

    function isEditable(status: string): boolean {
        return Constants.eicEditableStatuses.indexOf(status) > -1;
    }

    function isReviewable(status: string): boolean {
        return Constants.eicReviewableStatuses.indexOf(status) > -1;
    }

    var tabItems = Areas.createTabsWithSameController("Eic", ["InProcess", "Completed", "Deleted"], "List");
    
    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }
}